<template>
  <div
    class="resource-catalog-box"
    :class="expandedArrow ? '' : 'openTree'">
    <div
      class="resource-catalog-box-tree"
      :style="{ width: width + 'px' }"
      v-show="expandedArrow">
      <div class="header">
        <span
          class="title"
          v-show="expandedArrow">
          资源目录
        </span>
        <div
          class="operate-area"
          v-show="expandedArrow">
          <div class="icon-btn-box">
            <i
              class="el-icon-arrow-up"
              v-if="!openSilderMenu"
              @click="setAllExpand(true)"
              title="展开全部"></i>
            <i
              v-else
              class="el-icon-arrow-down"
              @click="setAllExpand(false)"
              title="折叠全部"></i>
          </div>
        </div>
      </div>
      <div class="common-tree-box">
        <el-tree
          class="tree-primary"
          ref="tree"
          :data="data"
          :props="defaultProps"
          node-key="nodeId"
          :indent="20"
          highlight-current
          default-expand-all
          :expand-on-click-node="false"
          @node-click="handleNodeClick">
          <div
            slot-scope="{ node, data }"
            class="custom-node-box">
            <div class="text-center-l">
              <div class="text-center-c">
                <img
                  class="custom-node-box-img"
                  v-if="data.nodeType === 3"
                  :src="
                    require(`@/assets/img/icon-mode${
                      node.label === '模型管理' ? '1' : '2'
                    }.png`)
                  "
                  alt="" />
                <icon-svg
                  v-if="data.isAuthorized && data.nodeType !== 3"
                  class="icon1"
                  icon-class="ic-ico_folder" />
                <icon-svg
                  v-if="!data.isAuthorized && data.nodeType !== 3"
                  class="icon1"
                  icon-class="ic-a-wenjianzhidu1" />
              </div>
            </div>
            <span
              class="node-lable text-overflow base-fontsize-14"
              :title="node.label"
              >{{ node.label }}</span
            >
          </div>
        </el-tree>
      </div>
    </div>
    <div
      class="expaned"
      @click="() => (expandedArrow = !expandedArrow)">
      <i
        v-if="!expandedArrow"
        size="14"
        class="el-icon-arrow-right el-icon"></i>
      <i
        v-else
        size="14"
        class="el-icon-arrow-left el-icon"></i>
    </div>
  </div>
</template>

<script>
import { getParentNode } from '@/utils/generalMethods'

export default {
  data() {
    return {
      defaultProps: {
        children: 'subNodes',
        label: 'nodeName'
      },
      expandedArrow: true,
      openSilderMenu: true
    }
  },
  props: {
    data: Array,
    nodeClick: Function,
    hideDataManageTree: Function,
    width: Number
  },
  methods: {
    handleNodeClick(data, node) {
      this.nodeClick(data, node)
    },
    getNode(nodeId) {
      let node = this.$refs.tree.getNode(nodeId)
      return node
    },
    setCurrentKey(nodeId) {
      if (!nodeId) {
        this.$refs.tree.setCurrentKey(null)
        return
      }
      let node = this.getNode(nodeId)
      if (node) {
        let parentNodes = []
        this.getParentNode(node, parentNodes)
        for (let i in parentNodes) {
          parentNodes[i].expanded = true
        }
        this.$refs.tree.setCurrentKey(nodeId)
      }
    },
    setAllExpand(state) {
      this.openSilderMenu = !this.openSilderMenu
      let nodes = this.$refs.tree.store._getAllNodes()
      for (let i in nodes) {
        nodes[i].expanded = state
      }
    },
    getDatasetIcon(status) {
      let icon = ''
      switch (status) {
        case 0:
          icon = 'ic-ico-model'
          break
        case 1:
          icon = 'ic-a-ico-Queueup1'
          break
        case 2:
          icon = 'ic-a-ico-Intransition1'
          break
        case 3:
          icon = 'ic-a-ico_Preconversion'
          break
        case 4:
          icon = 'ic-ico-failure1'
          break
        case 5:
          icon = 'ic-ico-success1'
          break
      }
      return icon
    },
    getParentNode
  }
}
</script>

<style lang="less" scoped>
.openTree {
  .expaned {
    right: -30px !important;
    z-index: 9;
    display: block !important;
  }
}

.resource-catalog-box-tree {
  padding: 16px;
  height: 100%;
}

.resource-catalog-box {
  margin-left: 16px;
  height: 100%;
  border-radius: 16px;
  background: var(--project-source-tree-bgColor);
  box-shadow: var(--base-bg-dark-color30);
  position: relative;
  border: 1px solid var(--project-source-tree-border-color);

  &:hover {
    .expaned {
      display: block;
    }
  }

  .header {
    display: flex;
    justify-content: space-between;

    .title {
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 12px;
      color: var(--project-source-tree-title-color);
    }

    .operate-area {
      display: flex;
      height: 26px;
      .icon-btn-box {
        margin-left: 5px;
        padding: 0px 5px;
        line-height: 26px;
        border-radius: 2px;
        background: var(--icon-bg-color);

        :deep(.el-icon-arrow-down) {
          &:hover {
            color: var(--base-primary-bgColor);
          }
          color: var(--project-source-tree-title-icon-color);
        }
        :deep(.el-icon-arrow-up) {
          &:hover {
            color: var(--base-primary-bgColor);
          }
          color: var(--project-source-tree-title-icon-color);
        }
      }
    }
  }

  .expaned {
    width: 24px;
    height: 40px;
    border-radius: 16px;
    background-color: var(--tree-expand-icon-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    border: 1px solid var(--tree-expand-icon-bgColor);
    position: absolute;
    top: 50%;
    right: -12px;
    transform: translateY(-50%);
    display: none;
    line-height: 40px;
    cursor: pointer;
    &:hover {
      background-color: var(--tree-expand-icon-hover-bgColor);
      box-shadow: var(--base-bg-dark-color30);
      border-color: transparent;
      border-radius: 16px;
    }

    .el-icon {
      font-weight: 600;
      color: var(--tree-expand-icon--color);
    }
  }

  .common-tree-box {
    height: calc(100% - 35px);
    overflow-y: auto;

    :deep(.el-tree-node__expand-icon) {
      padding-right: 4px;
      padding-left: 8px;
    }

    :deep(.el-tree-node__expand-icon.expanded) {
      margin-top: -6px;
    }

    .custom-node-box {
      display: flex;
      overflow: hidden;
      text-overflow: ellipsis;
      &-img {
        width: 20px;
        height: 20px;
        margin-right: 4px;
      }

      .node-lable {
        display: inline-block;
        width: 100%;
        text-align: left;
        font-size: 14px;
        vertical-align: text-bottom;
      }

      .icon1 {
        color: var(--icon-color);
        font-size: 20px;
        margin-right: 4px;
      }

      .icon2 {
        color: var(--icon-color);
        font-size: 20px;
        margin-right: 10px;
      }
    }
  }
}

.openTree {
  margin-left: 0px;
  border: none;
}
</style>
